import React, { useEffect, useState, useContext } from "react";
import $ from "jquery";
import "jquery-ui-dist/jquery-ui";
import "jquery-ui-dist/jquery-ui.css";
import { AuthContext } from "../../Routes/AuthProvider";
import { getAutoBusCities } from "../../Services/BusAPI";
import { useNavigate, useLocation } from "react-router-dom";
import { TravelPolicies } from "../../Services/API";

const ModifySearch = () => {
  const { name, userName, roles, corporateId } = useContext(AuthContext);
  const navigate = useNavigate();
  const location = useLocation();

  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");
  const [errors, setErrors] = useState({});
  const [selectedDate, setSelectedDate] = useState(null);

  const [selectedFromCity, setSelectedFromCity] = useState(null);
  const [selectedToCity, setSelectedToCity] = useState(null);

  const [fromSuggestions, setFromSuggestions] = useState([]);
  const [toSuggestions, setToSuggestions] = useState([]);

  const [fromTimer, setFromTimer] = useState(null);
  const [toTimer, setToTimer] = useState(null);
  const [travelTypeMode, setTravelTypeMode] = useState("1");

  const [travelType, setTravelType] = useState("Domestic");
  const [policies, setPolicies] = useState([]);


  const emulateCorporateCode = localStorage.getItem("selectedCorporateCode");
  const userId = emulateCorporateCode || corporateId;
  const CorpTravellerUserId = localStorage.getItem("selectedUserId");
  const CorpTraveller = CorpTravellerUserId ?? userName;
  useEffect(() => {
    if (!userName || !travelType || !userId || userId === "null" || userId === "undefined") return;
    const getTravelPolicies = async () => {
      try {
        const response = await TravelPolicies({
          UserName: CorpTraveller,
          ProductType: "Bus",
          CorporateCode: userId,
          TravelType: travelType
        });

        setPolicies(response);
        //console.log("getTravelPolicies", response);
      } catch (error) {
        console.error(error);
      }
    };
    getTravelPolicies();
  }, [userName, userId, travelType]);

  // ✅ PREFILL FROM URL OR STATE
  useEffect(() => {
    const query = new URLSearchParams(location.search);

    const fromCity = query.get("fromCity");
    const fromCityId = query.get("fromCityId");
    const toCity = query.get("toCity");
    const toCityId = query.get("toCityId");
    const journeyDate = query.get("journeyDate");

    if (fromCity) {
      setFrom(fromCity);
      setSelectedFromCity({
        cityName: fromCity,
        cityId: fromCityId,
      });
    }

    if (toCity) {
      setTo(toCity);
      setSelectedToCity({
        cityName: toCity,
        cityId: toCityId,
      });
    }

    if (journeyDate) {
      const date = new Date(journeyDate);
      setSelectedDate(date);

      setTimeout(() => {
        $("#departureDate").datepicker("setDate", date);
        updateDepartureUI(date);
      }, 200);
    }
  }, [location.search]);

  // ✅ SELECT FUNCTIONS
  const selectFrom = (city) => {
    setFrom(city.cityName);
    setSelectedFromCity(city);
    setFromSuggestions([]);
    setErrors((prev) => ({ ...prev, from: "" }));
  };

  const selectTo = (city) => {
    setTo(city.cityName);
    setSelectedToCity(city);
    setToSuggestions([]);
    setErrors((prev) => ({ ...prev, to: "" }));
  };

  // ✅ FROM API
  const handleFromChange = (e) => {
    const value = e.target.value;
    setFrom(value);
    setSelectedFromCity(null);

    if (fromTimer) clearTimeout(fromTimer);

    const timer = setTimeout(async () => {
      if (value.length > 2) {
        try {
          const res = await getAutoBusCities(value);
          const cities = res?.cities || res || [];

          // ✅ FILTER FIX
          const filtered = cities.filter((c) =>
            c.cityName?.toLowerCase().includes(value.toLowerCase())
          );

          setFromSuggestions(filtered.slice(0, 8));
        } catch {
          setFromSuggestions([]);
        }
      } else {
        setFromSuggestions([]);
      }
    }, 400);

    setFromTimer(timer);
  };

  // ✅ TO API
  const handleToChange = (e) => {
    const value = e.target.value;
    setTo(value);
    setSelectedToCity(null);

    if (toTimer) clearTimeout(toTimer);

    const timer = setTimeout(async () => {
      if (value.length > 2) {
        try {
          const res = await getAutoBusCities(value);
          const cities = res?.cities || res || [];

          // ✅ FILTER FIX
          const filtered = cities.filter((c) =>
            c.cityName?.toLowerCase().includes(value.toLowerCase())
          );

          setToSuggestions(filtered.slice(0, 8));
        } catch {
          setToSuggestions([]);
        }
      } else {
        setToSuggestions([]);
      }
    }, 400);

    setToTimer(timer);
  };

  // ✅ SWAP
  const swapCities = (e) => {
    e.preventDefault();

    setFrom(to);
    setTo(from);

    setSelectedFromCity(selectedToCity);
    setSelectedToCity(selectedFromCity);

    setFromSuggestions([]);
    setToSuggestions([]);
  };

  // ✅ DATE UI
  const updateDepartureUI = (date) => {
    setSelectedDate(date);

    setErrors((prev) => ({ ...prev, date: "" }));

    $("#dep_dayNum").text(("0" + date.getDate()).slice(-2));
    $("#dep_monthYear").text(
      `${date.toLocaleString("default", { month: "short" })}-${date.getFullYear()}`
    );
    $("#dep_dayName").text(
      date.toLocaleDateString("default", { weekday: "long" })
    );
  };

  useEffect(() => {
    $("#departureDate").datepicker({
      dateFormat: "dd-M-yy",
      minDate: 0,
      maxDate: "+4m",
      onSelect: function () {
        const date = $(this).datepicker("getDate");
        updateDepartureUI(date);
      },
    });

    return () => {
      $("#departureDate").datepicker("destroy");
    };
  }, []);

  useEffect(() => {
    const handleClickOutside = () => {
      setFromSuggestions([]);
      setToSuggestions([]);
    };

    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  // ✅ TODAY / TOMORROW
  const toDate = () => {
    const today = new Date();
    $("#departureDate").datepicker("setDate", today);
    updateDepartureUI(today);
  };

  const NextDate = () => {
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    $("#departureDate").datepicker("setDate", tomorrow);
    updateDepartureUI(tomorrow);
  };

  // ✅ SEARCH
  const handleBusSearch = (e) => {
    e.preventDefault();

    let newErrors = {};

    if (!selectedFromCity) newErrors.from = "Please select From city";
    if (!selectedToCity) newErrors.to = "Please select To city";
    if (!selectedDate) newErrors.date = "Please select journey date";

    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) return;

    const buslistData = {
      travelType: travelTypeMode,
      fromCity: selectedFromCity.cityName,
      fromCityId: selectedFromCity.cityId || selectedFromCity.id,
      toCity: selectedToCity.cityName,
      toCityId: selectedToCity.cityId || selectedToCity.id,
      journeyDate: `${selectedDate.getFullYear()}-${String(
        selectedDate.getMonth() + 1
      ).padStart(2, "0")}-${String(selectedDate.getDate()).padStart(2, "0")}`,
    };

    const query = new URLSearchParams(buslistData).toString();

    //  CLOSE MODAL (FIXED ID)
    const modalEl = document.getElementById("ModifyBusResult");

    if (modalEl && window.bootstrap) {
      const modalInstance =
        window.bootstrap.Modal.getInstance(modalEl) ||
        new window.bootstrap.Modal(modalEl);

      modalInstance.hide();
    }
    //  NAVIGATE
    navigate(`/bus/list?${query}`, {
      state: buslistData,
    });

    window.location.reload();
  };
  return (
    <>

      <div className='bus_serch'>
        <div className='row'>
          <div className='col-md-6 col-lg-6'>
            <div className='d-flex'>
               {policies?.approvalPolicy?.result?.corporateTravelTypeSettings?.isBusinessTravelEnabled === true && (
                <div className="travel_mode">
                  <div className="form-check form-check-custom form-check-solid">
                    <input className="form-check-input" type="radio" name="travelType" value="1"
                      checked={travelTypeMode === "1"}
                      onChange={(e) => {
                        setTravelTypeMode(e.target.value)
                      }}
                    />
                    <label className="form-check-label">Business Travel</label>
                  </div>
                </div>
              )}
              {policies?.approvalPolicy?.result?.corporateTravelTypeSettings?.isPersonalTravelEnabled === true && (
                <div className="travel_mode">
                  <div className="form-check form-check-custom form-check-solid">
                    <input className="form-check-input" type="radio" name="travelType" value="2"
                      checked={travelTypeMode === "2"}
                      onChange={(e) => {
                        setTravelTypeMode(e.target.value)
                      }}
                    />
                    <label className="form-check-label">Personal Travel</label>
                  </div>
                </div>
              )}
              {policies?.approvalPolicy?.result?.corporateTravelTypeSettings?.isGuestTravelEnabled === true &&
                ["TMC Operations", "TMC Manager", "Corp Travel Manager"].some(role => roles?.includes(role)) && (
                  <div className="travel_mode">
                    <div className="form-check form-check-custom form-check-solid">
                      <input className="form-check-input" type="radio" name="travelType" value="3"
                        checked={travelTypeMode === "3"}
                        onChange={(e) => {
                          setTravelTypeMode(e.target.value)
                        }}
                      />
                      <label className="form-check-label">Guest Travel</label>
                    </div>
                  </div>
                )}
            </div>
          </div>

          <div className='col-md-6 col-lg-6'>
            <div className='theme_tx'>
              <h3>Book Bus Tickets Online !</h3>
            </div>
          </div>
        </div>

        <div className='form_ful Modfy'>
          {/* FROM */}
          <div className='s_col_1'>
            <div className='bus_icon_img'>
              <img className='bus_ic' src='/assets/images/bus/bus.png' />
            </div>
            <div className='bus_icon'>
              <p>From</p>
              <input
                type="text"
                className="pick_form"
                value={from}
                onChange={handleFromChange}
                placeholder="From City"
              />

              {fromSuggestions.length > 0 && (
                <ul className="autosuggetsList">
                  {fromSuggestions.map((c, i) => (
                    <li key={i} onClick={() => selectFrom(c)}>
                      {c.cityName} - {c.state}
                    </li>
                  ))}
                </ul>
              )}
              <p className='area_nm'>
                {selectedFromCity ? selectedFromCity.state : "State.."}
              </p>

            </div>

            <a href="#" className="swiper_bus" onClick={swapCities}>
              <img alt="icon" src="/assets/images/swipe.png" />
            </a>
            {errors.from && <p className="error_mess">{errors.from}</p>}
          </div>
          {/* TO */}
          <div className='s_col_1'>
            <div className='bus_icon_img'>
              <img className='bus_ic' src='/assets/images/bus/bus.png' />
            </div>
            <div className='bus_icon'>
              <p>To</p>
              <input
                type="text"
                className="pick_form"
                value={to}
                onChange={handleToChange}
                placeholder="To City"
              />

              {toSuggestions.length > 0 && (
                <ul className="autosuggetsList">
                  {toSuggestions.map((c, i) => (
                    <li key={i} onClick={() => selectTo(c)}>
                      {c.cityName}, {c.state}
                    </li>
                  ))}
                </ul>
              )}
              <p className='area_nm'>
                {selectedToCity ? selectedToCity.state : "State.."}
              </p>
              {errors.to && <p className="error_mess">{errors.to}</p>}
            </div>
          </div>
          <div className='s_col_1 date_bssc'>
            <div className='bus_icon_img'>
              <img className='bus_ic' src='/assets/images/bus/date.png' />
            </div>
            <div className='bus_icon'>
              <p>Date of Journey</p>
              <div
                className="dest_nams"
                id="dateDisplay"
                onClick={() => $("#departureDate").datepicker("show")}
                style={{ cursor: "pointer" }}
              >
                <span id="dep_dayNum" style={{ fontSize: "28px", lineHeight: "1.1", fontWeight: "bold" }}>
                  DD
                </span>{" "}
                <span id="dep_monthYear" style={{ fontSize: "14px" }}>
                  MM-YYYY
                </span>
                <br />
                <span id="dep_dayName">
                  Day
                </span>
                <input
                  type="text"
                  id="departureDate"
                  style={{ position: "absolute", left: "0", opacity: "0" }}
                  readOnly
                />
              </div>
            </div>
            {errors.date && <p className="error_mess">{errors.date}</p>}
          </div>
          {/* <div className='s_col_1 date_bssc'>
            <button type="button" className="today" onClick={toDate}>
              Today
            </button>

            <button type="button" className="today" onClick={NextDate}>
              Tomorrow
            </button>
          </div> */}

          <div className='Rooms_Guests_Serch'>
            <a className='Serch' href='#' onClick={handleBusSearch}>
              Search
            </a>
          </div>
        </div>
      </div>

    </>
  );
};

export default ModifySearch;